import axios from 'axios'


export const API_URL = process.env.REACT_APP_API_URL || 'api'


export const Department_URL = `${API_URL}/api/Department`



export function GetDepartments(HotelId: any, accessToken: string) {
  return axios.get(`${Department_URL}?HotelId=${HotelId}`,
    {
      headers: {
        'Authorization': 'Bearer ' + accessToken
      }
    }
  );
}


export function GetDepartmentById(id: number, accessToken: string) {

  return axios.get(`${Department_URL}/${id}`
    , {
      headers: {
        'Authorization': 'Bearer ' + accessToken
      }
    });
}

export function PostDepartment(model: any, accessToken: string) {
  console.log('model values in PostRole -- ', model);
  return axios.post(`${Department_URL}`,
    model,
    {
      headers: {
        'Authorization': 'Bearer ' + accessToken
      }
    }
  );
}

export function UpdateDepartment(id: number, model: any, accessToken: string) {
  model.id = id;
  return axios.put(`${Department_URL}/${id}`, model, {
    headers: {
      'Authorization': 'Bearer ' + accessToken
    }
  });
}

export function DeleteDepartment(id: number, accessToken: string) {
  return axios.delete(`${Department_URL}/${id}`, {
    headers: {
      'Authorization': 'Bearer ' + accessToken
    }
  });
}